<template>
  <LimitedTimeBonus v-if="data && data.limited_time_bonus" :data="data" :isTdPost="true" />
</template>

<script>
import LimitedTimeBonus from '../../without_deposit/LimitedTimeBonus.vue';

export default {
  name: 'LimitedTimeBonusInline',
  components: { LimitedTimeBonus },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
